import React, { useState } from 'react';
import styles from '../TargetAudience.module.css';

import DebounceInput from '../../../../../campaigns/components/DebounceInput/DebounceInput';

import checkAgeGroupsSum from '../helpers/checkAgeGroupsSum/checkAgeGroupsSum';
import resetCrossedSample from '../helpers/resetCrossedSample/resetCrossedSample';
import getAccountManagementSampleSizeChargeWarning from '../../SurveyBuilder/helpers/getAccountManagementSampleSizeChargeWarning/getAccountManagementSampleSizeChargeWarning';
import getPermissionValue from '../../SurveyBuilder/helpers/getPermissionValue';
import { creditsToEuros } from '../../../../../portals/AccountManagement/helpers/creditsConversion/creditsConversion';

export default ({
  survey,
  onUpdateSurvey,
  userFilter,
  filterSettings,
  onUserFilterChange,
  accountManagement,
  setSurveyPermissionsCharge,
  surveyPermissionsCharge,
  setConfirmationPopup,
  defaultConstants
}) => {
  const [maxResponses, setMaxResponses] = useState(survey.maxResponses);

  return (
    <div className={styles.container}>
      <div className={styles.blockContainer}>
        <div className={styles.singleBlock}>
          <div className={`${styles.label} ${styles.descriptionCorrected}`}>
            Total sample size
          </div>
          <DebounceInput
            initialValue={maxResponses || ''}
            onChangeValue={value => {
              setMaxResponses(value);
              onUpdateSurvey({ maxResponses: value }, 0);

              // Calculate survey permissions charge after change
              const calculatedSurveyPermissionsCharge = getAccountManagementSampleSizeChargeWarning(
                {
                  ...survey,
                  maxResponses: value
                },
                accountManagement,
                surveyPermissionsCharge,
                defaultConstants.accountManagementDefaultPermissionValues
              );
              setSurveyPermissionsCharge(calculatedSurveyPermissionsCharge);

              if (
                calculatedSurveyPermissionsCharge &&
                calculatedSurveyPermissionsCharge.accountManagementSampleSizeWarning
              ) {
                const sampleSizeIncludedInLicence = getPermissionValue(
                  survey,
                  'sampleSizeIncludedInLicence'
                );

                const differenceInSampleSize =
                  value - (sampleSizeIncludedInLicence || 0);

                const confirmationPopup = {
                  onClick: () => {},
                  onClose: () => setConfirmationPopup(null),
                  onDontShowAnymoreChecked: () => {},
                  title: 'Are you sure?',
                  description: `The sample size you have entered exceeds the number of respondents included in your license by ${differenceInSampleSize}. Therefore, an additional charge of ${creditsToEuros(
                    calculatedSurveyPermissionsCharge
                      .surveySampleSizeChargeAmount.total
                  )} euros will be applied.`
                };

                setConfirmationPopup(confirmationPopup);
              }

              if (
                userFilter &&
                filterSettings &&
                filterSettings.crossedSample &&
                checkAgeGroupsSum(userFilter, maxResponses) !== 100
              ) {
                const newUserFilter = { ...userFilter };
                resetCrossedSample(
                  newUserFilter,
                  filterSettings,
                  onUserFilterChange
                );
              }
            }}
            className={styles.description}
            placeholder="Enter value here.."
            type="number"
            onKeyDown={evt =>
              evt.key === 'ArrowDown' ||
              evt.key === 'ArrowUp' ||
              evt.key === 'e' ||
              evt.key === 'E' ||
              evt.key === '.' ||
              evt.key === '-'
                ? evt.preventDefault()
                : null
            }
            debounceTime={300}
          />
        </div>
      </div>
    </div>
  );
};
